import React from 'react'
// import Sidebar from '../../components/admin_pannel/adminSidebar'

const MainDeshboard = () => {
  return (
    <div>
    {/* <Sidebar/> */}
    </div>
  )
}

export default MainDeshboard
